<div class="carousel-container">
  <div
    class="swipe-layer"
    appSwipe
    (next)="nextSlide()"
    (previous)="previousSlide()"
    (pointerdown)="onPointerDown($event)"
    (pointerup)="onPointerUp($event)"
    (pointercancel)="onPointerCancel()"
  >
    <div class="slides-wrapper" [style.transform]="translateX()">
      @for (slide of slides(); track slide.key; let i = $index) {
        <section class="slide">
          <div class="background">
            <img [src]="slide.backgroundImage" [alt]="'slides.' + slide.key + '.title' | transloco" />
          </div>
          <div class="image-overlay"></div>
          <div class="story-top">
            <div class="story-progress">
              @for (step of slides(); track $index; let stepIndex = $index) {
                <div class="story-progress__item">
                  <span
                    class="story-progress__fill"
                    [style.width.%]="getStepProgress(stepIndex)"
                  ></span>
                </div>
              }
            </div>
            <div class="story-header">
              @if (showSkip()) {
                <button
                  type="button"
                  class="skip-btn"
                  (click)="skip(); $event.stopPropagation()"
                >
                  {{ 'buttons.skip' | transloco }}
                </button>
              }
            </div>
          </div>
          <div class="story-content">
            <h1 class="title">
              {{ 'slides.' + slide.key + '.title' | transloco }}
            </h1>
            <p class="description">
              {{ 'slides.' + slide.key + '.description' | transloco }}
            </p>
          </div>
        </section>
      }
    </div>
  </div>
</div>
